export default "__VITE_ASSET__CbBmVjdD__"